'use strict';

const _ = require('lodash');

/*
 * Mimics the prototype collapsing behavior of _.merge in lodash 4
 */
function mergeEnumerable(obj) {
    if (!obj || (!_.isArray(obj) && obj.constructor.name !== 'Object')) {
        return obj;
    }

    // eslint-disable-next-line guard-for-in
    for (const key in obj) {
        // eslint-disable-next-line no-self-assign
        obj[key] = obj[key];
    }

    return _.mapValues(obj, function (v) {
        if (_.isArray(v)) {
            return _.map(v, mergeEnumerable);
        }
        return mergeEnumerable(v);
    });
}

module.exports = {
    mergeEnumerable: mergeEnumerable
};
